import React, { useState } from "react";

export default function Select({
  data,
  label,
  value,
  onChange,
  name,
  multi = false,
  ...props
}) {
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  const handleSelect = (item) => {
    if (multi) {
      let newValue;
      if (value.includes(item)) {
        newValue = value.filter((v) => v !== item);
      } else {
        newValue = [...value, item];
      }

      if (onChange) {
        onChange({
          target: {
            name,
            value: newValue,
          },
        });
      }
    } else {
      if (onChange) {
        onChange({
          target: {
            name,
            value: item,
          },
        });
      }
      setIsOpen(false); // close dropdown after selecting in single mode
    }
  };

  const isSelected = (item) => (multi ? value.includes(item) : value === item);

  return (
    <div className="quantity me-4 mb-1" style={{ zIndex: "99" }}>
      <select
        style={{ display: "none", width: "100%" }}
        multiple={multi}
        value={value}
        {...props}
      >
        <option value="">{label}</option>
        {data.map((item) => (
          <option key={item} value={item}>
            {item}
          </option>
        ))}
      </select>

      <div
        className="nice-select capitalize w-100"
        tabIndex={0}
        onClick={toggleDropdown}
      >
        <span className="current">
          {multi
            ? value.length > 0
              ? value.join(", ")
              : label
            : value || label}
        </span>

        {isOpen && (
          <ul className="list" style={{ zIndex: "99" }}>
            {data.map((item) => (
              <li
                key={item}
                data-value={item}
                className={`option capitalize ${
                  isSelected(item) ? "selected" : ""
                }`}
                onClick={(e) => {
                  e.stopPropagation();
                  handleSelect(item);
                }}
              >
                {multi && (
                  <input
                    type="checkbox"
                    checked={isSelected(item)}
                    readOnly
                    style={{ marginRight: "8px" }}
                  />
                )}
                {item}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
